<h2 mat-dialog-title>Add page to report</h2>

<mat-dialog-content>
  <app-page-grid 
    *ngIf="currentView === 'grid'"
    [pages]="pageLibrary"
    [testType]="testType"
    [initialChip]="selectedChip"
    (chipSelected)="onChipSelected($event)"
    (pageSelected)="onPageSelected($event)">
  </app-page-grid>

  <app-page-detail
    *ngIf="currentView === 'detail' && selectedPage"
    [page]="selectedPage"
    (back)="onBack()"
    (pageInsert)="onPageInsert($event)">
  </app-page-detail>
</mat-dialog-content>